import React from 'react'

function ConfirmacionEgresoQRData (props) {
  const { data } = props

  const renderDetalle = () => {
    const detalle = data.map((d, i) => {
      return (
        (d.show) && <div key={`${d.titulo}-${i}`} className='container-dato'>
          <h4 className='titulo-dato'>{d.nombre}</h4>
          <h1 className='texto-dato'> {d.value}</h1>
        </div>
      )
    })
    return detalle
  }

  return (
    <div className='datos-confirmacion-egreso'>
      {renderDetalle()}
    </div>
  )
}

export default ConfirmacionEgresoQRData
